import axios from "axios";

const instance = axios.create({
  baseURL: "/api",
  withCredentials: true,
});

instance.defaults.headers.common["Content-Type"] = "application/json";

instance.interceptors.request.use((config) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (userData?.token) {
    config.headers.Authorization = `Bearer ${userData.token}`;
  } else {
    delete config.headers.Authorization;
  }
  return config;
});

export default instance;

